import SharesChart from './SharesChart';

export default SharesChart;
